import { ProfileAdditionalRole, type ProfileRoleList } from '../types/profileRoles';

export function hasProfileRole(
  roles: ProfileRoleList | null | undefined,
  role: ProfileAdditionalRole
): boolean {
  return Array.isArray(roles) && roles.includes(role);
}

export function hasDeveloperAccess(roles: ProfileRoleList | null | undefined): boolean {
  return hasProfileRole(roles, ProfileAdditionalRole.Dev);
}
